export default {
    namespaced: true,
    state: {
        requiredDictionaries: [],
        options: {
            page: 1,
            itemsPerPage: 100,
            sortBy: ['id'],
            sortDesc: [true],
            rowsPerPageItems: [50, 100, 200, 400],
        },
        refreshTime: localStorage.getItem('refreshTime') ? parseInt(localStorage.getItem('refreshTime')) : 15,
        timer: '',
        rules: {},
        tableHeight: null,
        total: 0,
        loading: false,
        dialogEdit: false,
        dialogDelete: false,
        action: '',
        cloneItem: {},
        item: {},
    },
    mutations: {
        setOptions(state, options) {
            state.options = options;
        },
        setLoading(state, loading) {
            state.loading = loading;
        },
        setTotal(state, total) {
            state.total = total;
        },
        setTableHeight(state, tableHeight) {
            state.tableHeight = tableHeight;
        },
        setDialogEdit(state, dialogEdit) {
            state.dialogEdit = dialogEdit;
        },
        setDialogDelete(state, dialogDelete) {
            state.dialogDelete = dialogDelete;
        },
        setItem(state, item) {
            state.item = item;
        },
        setCloneItem(state, cloneItem) {
            state.cloneItem = cloneItem;
        },
        setAction(state, action) {
            state.action = action;
        },
        setRequiredDictionaries(state, requiredDictionaries) {
            state.requiredDictionaries = Array.from(new Set(state.requiredDictionaries.concat(requiredDictionaries)));
        },
        setRules(state, rules) {
            state.rules = rules;
        },
        setRefreshTime(state, refreshTime) {
            state.refreshTime = refreshTime;
        },
        setTimer(state, timer) {
            state.timer = timer;
        },
    },
    getters: {
        getOptions(state) {
            return state.options;
        },
        getLoading(state) {
            return state.loading;
        },
        getTotal(state) {
            return state.total;
        },
        getTableHeight(state) {
            return state.tableHeight;
        },
        getDialogEdit(state) {
            return state.dialogEdit;
        },
        getDialogDelete(state) {
            return state.dialogDelete;
        },
        getItem(state) {
            return state.item;
        },
        getCloneItem(state) {
            return state.cloneItem;
        },
        getAction(state) {
            return state.action;
        },
        getRequiredDictionaries(state) {
            return state.requiredDictionaries;
        },
        getRules(state) {
            return state.rules;
        },
        getRefreshTime(state) {
            return state.refreshTime;
        },
        getTimer(state) {
            return state.timer;
        },
    },
    actions: {},
};
